import React from "react";

const Features = () => {

    const features = [
        {
            icon: "M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z",
            title: "Security",
            description: "Lorem Ipsum is simply dummy text of the printing industry. Proin vulputate metus in commodo iaculis."
        },
        {
            icon: "M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z",
            title: "Instant Settlement",
            description: "Lorem Ipsum is simply dummy text of the printing industry. Proin vulputate metus in commodo iaculis."
        },
        {
            icon: "M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z",
            title: "Decentralization",
            description: "Lorem Ipsum is simply dummy text of the printing industry. Proin vulputate metus in commodo iaculis."
        }

    ]


    return <section id="features" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
                <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">Features Overview</h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 justify-items-center">
                {
                    features.map((feature, index) => (
                        <div key={index} className="w-3/4 sm:w-1/2 md:w-auto">
                            <FeatureCard icon={feature.icon} title={feature.title} description={feature.description} />
                        </div>
                    ))
                }
            </div>
        </div>
    </section>;
};

export default Features;

const FeatureCard = ({ icon, title, description }) => {
    return <div className="bg-white rounded-2xl p-8 relative" style={{ boxShadow: '0px 8px 30px 0px #80808033' }}>
        <div className="w-[5px] h-16 bg-[#56B22F] mx-auto mb-4 absolute top-10 left-[-5px] rounded-full"></div>
        <div className="w-20 h-20 bg-[#56B22F] rounded-full flex items-center justify-center mb-6">
            {
                icon && (
                    <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={icon} />
                    </svg>
                )
            }
        </div>
        <h3 className="text-2xl font-semibold mb-4">{title}</h3>
        <p className="text-gray-600">
            {description}
        </p>
    </div>
}
